const addClassToHtmlElement = (className) => {
    document.documentElement.classList.add(className);

    return () => {
        document.documentElement.classList.remove(className);
    };
};

export { addClassToHtmlElement };
